const uz = {
    meta: {
        title: "IT Park rezidentligi 2026: imtiyozlar va kimga mos",
        description:
            "IT Park rezidentligi: tasdiqlangan soliq imtiyozlari, kim kira oladi, hujjat tartibi va majburiyatlar, tejamkorlik formulasi va qachon bu maqom ortiqcha.",
        keywords: [
            "IT Park rezidenti bo'lish shartlari",
            "IT Park soliq imtiyozlari",
            "IT Park rezidenti uchun talablar",
            "IT kompaniya ochish O'zbekistonda",
            "IT eksport imtiyozi",
            "IT Park rezidentligi qancha turadi",
        ],
    },
    h1: "IT Park rezidentligi: kimga foyda, qanday imtiyoz va qachon ortiqcha",
    lead:
        "IT Park rezidentligi ko'pincha «faqat IT firmalar uchun» deb tushuniladi. Amalda o'z dasturiy mahsulotini ishlab chiqadigan savdo yoki ishlab chiqarish kompaniyasi ham unga kira oladi. Quyida tasdiqlangan imtiyozlar, tejamkorlikni hisoblash formulasi va halol chegara — qachon bu ma'muriy yuk foydadan katta bo'ladi.",
    category: "Loyiha iqtisodi",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Rezidentlik haqida ikki xil noto'g'ri tasavvur bor. Birinchisi — «bu faqat dasturiy ta'minot sotadigan kompaniyalar uchun». Ikkinchisi — «u yerda soliq umuman yo'q». Ikkalasi ham to'liq to'g'ri emas, va farqni bilish byudjet qaroriga bevosita ta'sir qiladi.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Rezidentlik qanday imtiyoz beradi?" },
        {
            type: "p",
            text:
                "Quyidagilar rasmiy manbada — O'zbekiston IT autsorsing portalining davlat qo'llab-quvvatlash bo'limida — ko'rsatilgan imtiyozlar. Boshqa raqamlarni qo'shmaymiz, chunki ular tasdiqlanmagan.",
        },
        {
            type: "list",
            items: [
                "Foyda solig'idan ozod qilish.",
                "Mol-mulk solig'idan ozod qilish.",
                "Bojxona to'lovlaridan ozod qilish.",
                "Olib kirilayotgan uskuna uchun qo'shilgan qiymat solig'idan ozod qilish.",
                "Virtual ofis huquqi — rezident bo'lish uchun alohida jismoniy ofis talab qilinmaydi.",
                "Chet ellik mutaxassisni alohida ruxsatnomasiz ishga jalb qilish imkoniyati.",
            ],
        },
        {
            type: "p",
            text:
                "Muhim izoh: bu ro'yxatga kirmagan hamma narsa odatdagidek qoladi. Xodimlar ish haqi bo'yicha majburiyatlar, ijtimoiy to'lovlar va boshqa soliqlar alohida hisoblanadi — ularning amaldagi tartibini buxgalteringiz bilan tasdiqlang.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Imtiyozdan qancha tejaladi?" },
        {
            type: "p",
            text:
                "Bu savolga universal javob yo'q, lekin formula oddiy. Tejamkorlik — imtiyozga kiruvchi soliqlar bazasini amaldagi stavkaga ko'paytirish.",
        },
        {
            type: "callout",
            text:
                "Yillik tejamkorlik ≈ (soliqqa tortiladigan foyda × foyda solig'i stavkasi) + (mol-mulk bazasi × mol-mulk solig'i stavkasi) + olib kirilayotgan uskuna bo'yicha bojxona va QQS summasi.",
        },
        {
            type: "p",
            text:
                "Stavkalarni amaldagi Soliq kodeksidan yoki buxgalteringizdan oling — ular faoliyat turiga qarab farq qiladi va o'zgarib turadi. Biz bu yerda stavka yozmaymiz, chunki eskirgan raqam noto'g'ri qarorga olib keladi.",
        },
        {
            type: "p",
            text:
                "Misol shakli shunday: agar yillik soliqqa tortiladigan foydangiz 800 000 000 so'm bo'lsa va amaldagi foyda solig'i stavkasi 15% bo'lsa, faqat shu moddadan tejamkorlik 120 000 000 so'mni tashkil qiladi. O'z foydangizni va o'z stavkangizni qo'yib chiqing.",
        },
        {
            type: "p",
            text:
                "Endi eng muhim qadam: chiqqan summani ma'muriy xarajat bilan solishtiring. Agar tejamkorlik alohida yuridik shaxs yuritish, buxgalteriya va hisobot xarajatlaridan kam bo'lsa — rezidentlik sizga foyda keltirmaydi.",
        },

        { type: "h2", text: "Kim rezident bo'la oladi?" },
        {
            type: "p",
            text:
                "Asosiy shart — faoliyat turi. Kompaniya dasturiy mahsulot yoki IT xizmat ishlab chiqarishi va sotishi kerak. Bu dasturiy ta'minot, mobil ilova, veb-platforma, ma'lumotlar bilan ishlash, dizayn va IT autsorsing bo'lishi mumkin.",
        },
        {
            type: "p",
            text:
                "Ko'pchilik e'tibordan chetda qoldiradigan nuqta shu: talab kompaniya tarixiga emas, faoliyat predmetiga qo'yiladi. Ya'ni savdo yoki ishlab chiqarish kompaniyasi ham o'z IT bo'limini alohida yuridik shaxsga ajratib, shu orqali rezidentlikka kirishi mumkin.",
        },
        {
            type: "p",
            text:
                "Bu sxema ikkita shart bilan ishlaydi. Birinchisi — yangi yuridik shaxs haqiqiy faoliyat yuritishi, shartnomalar va hisobot bo'yicha mustaqil bo'lishi kerak. Ikkinchisi — ichki xizmatlar bozor narxida rasmiylashtirilishi shart. Qog'ozdagi bo'linish emas, real bo'linish talab qilinadi.",
        },
        {
            type: "p",
            text:
                "Amaliy maslahat: bu qadamni buxgalter va yurist bilan birga rejalashtiring. Ikki yuridik shaxs o'rtasidagi ichki shartnomalar, transfert narxlari va hujjat aylanishi keyinchalik tekshiruvda ko'riladigan asosiy joy bo'ladi. Boshidan to'g'ri qurilgan sxemani keyin tuzatishdan ko'ra arzonroq.",
        },

        { type: "h2", text: "Ariza va hujjatlar tartibi qanday?" },
        {
            type: "p",
            text:
                "Tartib bosqichma-bosqich va uni odatda buxgalter yoki yurist bilan birga o'tish kerak. Quyidagi ketma-ketlik amaliyotimizdan olingan.",
        },
        {
            type: "ol",
            items: [
                "Faoliyat turini aniqlang va u rezidentlik uchun ruxsat etilgan yo'nalishlarga kirishini tekshiring.",
                "Kerak bo'lsa alohida yuridik shaxs tashkil eting yoki mavjudining ustav faoliyatini moslashtiring.",
                "Ariza va ta'sis hujjatlarini tayyorlang: guvohnoma, STIR, ustav, rahbar ma'lumotlari, bank rekvizitlari.",
                "Faoliyat rejasi va mahsulot tavsifini tayyorlang — bu hujjat ko'pincha yetishmaydi va jarayonni cho'zadi.",
                "Arizani IT Park direksiyasiga topshiring va ko'rib chiqish natijasini kuting.",
                "Ijobiy qaror chiqqach, hisobot tartibini buxgalteriyaga kiriting — rezidentlik doimiy majburiyatlar bilan keladi.",
            ],
        },
        {
            type: "p",
            text:
                "Muddat bo'yicha aniq kafolat berilmaydi va u hujjatlar to'liqligiga bog'liq. Amaliy tavsiya: rejani rezidentlik olinishiga bog'lab qo'ymang — ishni parallel olib boring.",
        },

        { type: "h2", text: "Rezidentlikning doimiy majburiyatlari nimadan iborat?" },
        {
            type: "p",
            text:
                "Imtiyoz bepul emas — u hisobot va muvofiqlik yuki bilan keladi. Bu qismni oldindan bilish qaror uchun imtiyozlar ro'yxatidan kam ahamiyatli emas.",
        },
        {
            type: "list",
            items: [
                "Belgilangan davriylikda hisobot topshirish va faoliyat ko'rsatkichlarini tasdiqlash.",
                "Faoliyat turini saqlash — daromadning asosiy qismi ruxsat etilgan yo'nalishdan kelishi kerak.",
                "Direksiyaga ajratma to'lash. 2026-yilda bu tartib o'zgargani haqida ma'lumotlar tarqaldi, lekin biz tasdiqlovchi hujjat raqamini topa olmadik — shuning uchun bu yerda raqam keltirmaymiz. Amaldagi miqdor va tartibni rasmiy manbadan tekshiring.",
                "Alohida yuridik shaxs bo'lsa — mustaqil buxgalteriya, bank hisobi va hujjat aylanishi.",
                "Talablar buzilganda rezidentlik to'xtatilishi mumkin, shu sababli muvofiqlikni kuzatib borish kerak.",
            ],
        },

        { type: "h2", text: "Rezident va oddiy kompaniya: nima farq qiladi?" },
        {
            type: "p",
            text:
                "Quyidagi jadval qarorni tez qabul qilish uchun. U raqam bermaydi — u qaysi moddalarni o'z hisobingizda taqqoslash kerakligini ko'rsatadi.",
        },
        {
            type: "table",
            head: ["Modda", "IT Park rezidenti", "Oddiy kompaniya", "Nimani hisoblash kerak"],
            rows: [
                [
                    "Foyda solig'i",
                    "Ozod qilingan",
                    "Umumbelgilangan tartibda",
                    "Yillik soliqqa tortiladigan foyda × amaldagi stavka",
                ],
                [
                    "Mol-mulk solig'i",
                    "Ozod qilingan",
                    "Umumbelgilangan tartibda",
                    "Mol-mulk bazasi × amaldagi stavka",
                ],
                [
                    "Uskuna import qilish",
                    "Bojxona to'lovi va QQS dan ozod",
                    "To'liq to'lanadi",
                    "Yaqin 2 yilda rejalashtirilgan import qiymati",
                ],
                [
                    "Ofis",
                    "Virtual ofis yetarli",
                    "Jismoniy manzil talab qilinadi",
                    "Ofis ijarasidagi tejamkorlik",
                ],
                [
                    "Chet ellik mutaxassis",
                    "Alohida ruxsatnomasiz jalb qilish mumkin",
                    "Umumiy tartibda rasmiylashtiriladi",
                    "Rasmiylashtirishga ketadigan vaqt va xarajat",
                ],
                [
                    "Ma'muriy yuk",
                    "Hisobot, ajratma, faoliyat turini saqlash",
                    "Odatdagi hisobot",
                    "Buxgalteriya va yuridik xizmat yillik narxi",
                ],
            ],
        },

        { type: "h2", text: "Qachon rezidentlik sizga ortiqcha bo'ladi?" },
        {
            type: "p",
            text:
                "Bu bo'limni ko'p manba yozmaydi, lekin amaliyotda eng ko'p kerak bo'ladigan qism aynan shu. Quyidagi holatlarda rezidentlik tejamkorlikdan ko'ra ko'proq vaqt oladi.",
        },
        { type: "image", image: 2 },
        {
            type: "list",
            items: [
                "Jamoangiz kichik va foyda kam. Foyda solig'i imtiyozi soliqqa tortiladigan foydaga bog'liq — foyda kichik bo'lsa, tejamkorlik ham kichik bo'ladi.",
                "Tizim faqat ichki foydalanish uchun. Agar dasturiy mahsulot sotilmasa va faqat o'z jarayoningizga xizmat qilsa, faoliyat turi bo'yicha shart bajarilmasligi mumkin.",
                "Alohida yuridik shaxs yuritishga resurs yo'q. Ikkinchi buxgalteriya, ikkinchi hisobot va ichki shartnomalar — bu doimiy xarajat.",
                "Rejangiz bir yildan qisqa. Ariza, tashkil etish va sozlash vaqti qisqa loyihada o'zini oqlamaydi.",
                "Asosiy daromadingiz boshqa yo'nalishdan keladi va uni ajratish biznes mantiqini buzadi.",
            ],
        },
        {
            type: "p",
            text:
                "Oddiy tekshiruv: yillik tejamkorlikni hisoblang va undan alohida yuridik shaxsning yillik ma'muriy xarajatini ayiring. Natija musbat va sezilarli bo'lsagina rezidentlik iqtisodiy ma'noga ega. Farq kichik chiqsa, qarorni keyingi yilga qoldiring — foyda o'sganda hisob o'zi o'zgaradi.",
        },

        { type: "h2", text: "Rezidentlikka bormasangiz nima yo'qotasiz?" },
        {
            type: "p",
            text:
                "Yo'qotish ikki xil. Birinchisi to'g'ridan-to'g'ri: yuqoridagi formula bo'yicha hisoblangan soliq summasi har yili to'lanib boraveradi. Foydasi katta IT kompaniyasi uchun bu sezilarli raqam.",
        },
        {
            type: "p",
            text:
                "Ikkinchisi ko'rinmasroq — kadr va uskuna masalasi. Chet ellik mutaxassisni jalb qilish va texnikani import qilish bo'yicha yengillik bo'lmasa, o'sish bosqichida har ikkala jarayon ham sekinlashadi. Bu pul emas, vaqt yo'qotish, lekin u ham narxga aylanadi.",
        },
        {
            type: "quote",
            text:
                "Imtiyoz o'z-o'zidan foyda emas. Foyda — tejalgan summa ma'muriy yukdan katta bo'lgandagina paydo bo'ladi.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Qaror uchun to'rtta savol" },
        {
            type: "ol",
            items: [
                "Dasturiy mahsulot yoki IT xizmatingiz sotiladimi yoki faqat ichkarida ishlatiladimi?",
                "Yillik soliqqa tortiladigan foydangiz qancha va imtiyozdan qancha tejaladi?",
                "Alohida yuridik shaxsni yuritishga sizda resurs bormi?",
                "Rejangiz gorizonti bir yildan uzunmi?",
            ],
        },
        {
            type: "p",
            text:
                "Birinchi savolga «sotiladi», ikkinchisiga sezilarli summa va qolgan ikkitasiga «ha» javobi chiqsa — rezidentlik sizga foydali. Aralash javoblarda avval hisobni yakunlang, keyin ariza bering.",
        },
    ],

    faq: [
        {
            q: "IT Park rezidenti qaysi soliqlardan ozod qilinadi?",
            a: "Rasmiy manbada ko'rsatilgan imtiyozlar: foyda solig'i, mol-mulk solig'i, bojxona to'lovlari va olib kirilayotgan uskuna uchun qo'shilgan qiymat solig'idan ozod qilish. Bundan tashqari virtual ofis huquqi va chet ellik mutaxassisni alohida ruxsatnomasiz jalb qilish imkoniyati beriladi. Ro'yxatga kirmagan boshqa majburiyatlar odatdagi tartibda qoladi.",
        },
        {
            q: "Savdo yoki ishlab chiqarish kompaniyasi rezident bo'la oladimi?",
            a: "Ha, agar IT yo'nalishi alohida yuridik shaxsga ajratilsa va shu shaxsning faoliyati dasturiy mahsulot yoki IT xizmat ishlab chiqarishga qaratilgan bo'lsa. Sxema ikki shart bilan ishlaydi: yangi kompaniya haqiqiy faoliyat yuritishi va ichki xizmatlar bozor narxida rasmiylashtirilishi kerak. Qog'ozdagi bo'linish emas, real bo'linish talab qilinadi.",
        },
        {
            q: "Direksiyaga ajratma qancha to'lanadi?",
            a: "Bu yerda aniq raqam bermaymiz va buning sababi ochiq. 2026-yilda ajratma tartibi o'zgargani haqida ma'lumotlar tarqaldi, lekin biz uni tasdiqlovchi hujjat raqamini topa olmadik, tasdiqlanmagan raqamni esa yozmaymiz — noto'g'ri summa asosida tuzilgan byudjet qarori zarar keltiradi. Amaldagi miqdor va hisoblash tartibini IT Park direksiyasining rasmiy manbasidan yoki o'z buxgalteringiz orqali tekshiring.",
        },
        {
            q: "Rezidentlik qancha vaqtda rasmiylashtiriladi?",
            a: "Aniq kafolatlangan muddat yo'q va u hujjatlar to'liqligiga bog'liq. Eng ko'p vaqtni faoliyat rejasi va mahsulot tavsifi oladi — aynan shu hujjat ko'pincha yetishmaydi yoki juda umumiy yoziladi va qayta so'raladi. Amaliy tavsiya: ishlab chiqish rejasini rezidentlik olinishiga bog'lab qo'ymang, ikkala jarayonni parallel olib boring. Aks holda mahsulot ishga tushishi ma'muriy jarayonga bog'lanib qoladi.",
        },
        {
            q: "Rezidentlik qaytarib olinishi mumkinmi?",
            a: "Ha. Rezidentlik doimiy majburiyatlar bilan keladi: belgilangan davriylikda hisobot topshirish, faoliyat turini saqlash va daromadning asosiy qismini ruxsat etilgan yo'nalishdan olish. Talablar buzilganda maqom to'xtatilishi mumkin, imtiyozlar esa shu bilan birga to'xtaydi. Shuning uchun muvofiqlikni buxgalteriya jarayoniga kiritib qo'yish kerak va uni yiliga bir marta eslanadigan voqea sifatida qoldirmaslik lozim.",
        },
        {
            q: "Kichik jamoaga rezidentlik kerakmi?",
            a: "Ko'p hollatda yo'q. Foyda solig'i bo'yicha imtiyoz soliqqa tortiladigan foydaga bog'liq: foyda kichik bo'lsa, tejamkorlik ham kichik chiqadi. Alohida yuridik shaxs esa doimiy buxgalteriya, hisobot va ichki shartnomalar talab qiladi. Avval tejamkorlikni hisoblang, keyin undan yillik ma'muriy xarajatni ayiring va natijaga qarab qaror qiling.",
        },
    ],

    cta: {
        h: "Rezidentlik sizga foydalimi — birga hisoblaymiz",
        p:
            "Faoliyat turingizni va moliyaviy ko'rsatkichlaringizni ko'rib, tejamkorlikni ma'muriy xarajat bilan solishtirib beramiz. Agar rezidentlik sizga ortiqcha bo'lsa, buni ochiq aytamiz.",
        button: "Konsultatsiya olish",
    },

    images: [
        {
            src: "/assets/img/blog/it-park-ofis.webp",
            alt: "Zamonaviy texnopark ofisi — IT kompaniyalar ishlaydigan muhit",
            caption: "Rezidentlik — bino emas, maqom: virtual ofis ham yetarli",
            prompt:
                "Modern tech-park office lobby with a glass facade, developers walking through, a wall of monitors in the background; bright architectural photography style, neutral corporate palette, no brand signage, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/it-park-imtiyozlar.webp",
            alt: "IT Park rezidentiga beriladigan to'rtta asosiy imtiyoz ko'rsatilgan panel",
            caption: "Ro'yxatga kirmagan hamma narsa odatdagi tartibda qoladi",
            prompt:
                "Benefits panel: four tiles with simple icons representing profit tax exemption, property tax exemption, customs duty relief on imported equipment, and hiring foreign specialists without a permit; clean flat tiles on light background, blue and green, no readable text, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/it-park-qaror.webp",
            alt: "IT Park rezidentligi kerakmi degan savolga javob beruvchi qaror daraxti",
            caption: "Javob faoliyat turidan boshlanadi, imtiyozlar ro'yxatidan emas",
            prompt:
                "Decision flowchart with diamond decision nodes: does the company produce software or IT services for sale or export, leading to three outcomes — residency worth it, worth it via a separate legal entity, not worth it; clean flowchart on light background, blue with one grey exit branch, no readable text, no logos, 4:3",
        },
        {
            src: "/assets/img/projects/ung-academy.webp",
            alt: "UNG Academy platformasi — o'z dasturiy mahsulotini ishlab chiqqan kompaniya misoli",
            caption: "O'z mahsuloti sotiladigan kompaniya — rezidentlik uchun eng aniq holat",
        },
    ],

    relatedServices: ["it-autsorsing", "startap-saytlar", "veb-ilovalar"],
    relatedPosts: ["oz-dasturchisi-yoki-autsorsing", "ariza-tannarxi-seo-ads-instagram", "web-sayt"],
};

const ru = {
    meta: {
        title: "Резидентство IT Park 2026: льготы и кому это выгодно",
        description:
            "Резидентство IT Park: подтверждённые налоговые льготы, кто может войти, документы и обязанности, формула расчёта экономии и когда статус оказывается лишним.",
        keywords: [
            "как стать резидентом IT Park Узбекистан",
            "налоговые льготы IT Park",
            "требования к резидентам IT Park",
            "открыть IT-компанию в Узбекистане",
            "льготы на экспорт IT-услуг",
            "сколько стоит резидентство IT Park",
        ],
    },
    h1: "Резидентство IT Park: кому выгодно, какие льготы и когда это лишнее",
    lead:
        "Резидентство IT Park часто воспринимают как историю «только для айтишников». На деле войти может и торговая или производственная компания, которая разрабатывает собственный программный продукт. Разбираем подтверждённые льготы, формулу расчёта экономии и честную границу — когда административная нагрузка перевешивает выгоду.",
    category: "Экономика проекта",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "Вокруг резидентства закрепились два неверных представления. Первое — «это только для компаний, которые продают софт». Второе — «там вообще нет налогов». Оба неточны, и понимание разницы напрямую влияет на бюджетное решение.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Какие льготы даёт резидентство?" },
        {
            type: "p",
            text:
                "Ниже перечень из официального источника — раздела о государственной поддержке на портале IT-аутсорсинга Узбекистана. Других цифр мы не добавляем, потому что подтвердить их не удалось.",
        },
        {
            type: "list",
            items: [
                "Освобождение от налога на прибыль.",
                "Освобождение от налога на имущество.",
                "Освобождение от таможенных платежей.",
                "Освобождение от НДС на ввозимое оборудование.",
                "Право на виртуальный офис — отдельное физическое помещение для статуса не требуется.",
                "Возможность привлекать иностранных специалистов без отдельного разрешения.",
            ],
        },
        {
            type: "p",
            text:
                "Важная оговорка: всё, что не вошло в этот список, остаётся в обычном порядке. Обязательства по заработной плате сотрудников, социальные платежи и прочие налоги считаются отдельно — действующий порядок уточните у своего бухгалтера.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Сколько получится сэкономить?" },
        {
            type: "p",
            text:
                "Универсального ответа здесь нет, но формула простая. Экономия — это база льготируемых налогов, умноженная на действующие ставки.",
        },
        {
            type: "callout",
            text:
                "Годовая экономия ≈ (налогооблагаемая прибыль × ставка налога на прибыль) + (база по имуществу × ставка налога на имущество) + сумма таможенных платежей и НДС по ввозимому оборудованию.",
        },
        {
            type: "p",
            text:
                "Ставки берите из действующей редакции Налогового кодекса или у бухгалтера — они различаются по видам деятельности и периодически меняются. Мы сознательно не приводим здесь конкретную ставку: устаревшая цифра приводит к неверному решению.",
        },
        {
            type: "p",
            text:
                "Пример выглядит так: если годовая налогооблагаемая прибыль составляет 800 000 000 сум, а действующая ставка налога на прибыль равна 15%, только по этой статье экономия составит 120 000 000 сум. Подставьте собственную прибыль и собственную ставку.",
        },
        {
            type: "p",
            text:
                "Следующий шаг — главный: сравните полученную сумму с административными расходами. Если экономия меньше, чем стоят содержание отдельного юрлица, бухгалтерия и отчётность, резидентство вам ничего не принесёт.",
        },

        { type: "h2", text: "Кто может стать резидентом?" },
        {
            type: "p",
            text:
                "Основное условие — вид деятельности. Компания должна разрабатывать и продавать программный продукт или IT-услуги. Это может быть софт, мобильное приложение, веб-платформа, работа с данными, дизайн или IT-аутсорсинг.",
        },
        {
            type: "p",
            text:
                "Момент, который чаще всего упускают: требование предъявляется к предмету деятельности, а не к истории компании. То есть торговая или производственная компания может выделить своё IT-направление в отдельное юрлицо и войти в статус через него.",
        },
        {
            type: "p",
            text:
                "Схема работает при двух условиях. Первое — новое юрлицо должно вести реальную деятельность и быть самостоятельным по договорам и отчётности. Второе — внутренние услуги оформляются по рыночной цене. Требуется настоящее разделение, а не формальность на бумаге.",
        },
        {
            type: "p",
            text:
                "Практический совет: планируйте этот шаг вместе с бухгалтером и юристом. Внутренние договоры между двумя юрлицами, трансфертные цены и документооборот — именно то, на что в первую очередь смотрят при проверке. Выстроить схему корректно сразу дешевле, чем переделывать её позже.",
        },

        { type: "h2", text: "Как устроен порядок подачи документов?" },
        {
            type: "p",
            text:
                "Порядок пошаговый, и проходить его лучше вместе с бухгалтером или юристом. Последовательность ниже взята из нашей практики.",
        },
        {
            type: "ol",
            items: [
                "Определите вид деятельности и проверьте, входит ли он в разрешённые для резидентства направления.",
                "При необходимости создайте отдельное юрлицо или приведите уставную деятельность существующего в соответствие.",
                "Подготовьте заявление и учредительные документы: свидетельство, ИНН, устав, данные руководителя, банковские реквизиты.",
                "Подготовьте план деятельности и описание продукта — именно этого документа чаще всего не хватает, и процесс затягивается.",
                "Подайте заявление в дирекцию IT Park и дождитесь результата рассмотрения.",
                "После положительного решения встройте отчётность в работу бухгалтерии: статус приходит вместе с постоянными обязанностями.",
            ],
        },
        {
            type: "p",
            text:
                "Гарантированного срока не называют, он зависит от полноты документов. Практический совет: не привязывайте план разработки к получению статуса — ведите оба процесса параллельно.",
        },

        { type: "h2", text: "Какие обязанности возникают у резидента?" },
        {
            type: "p",
            text:
                "Льгота не бесплатна — она приходит вместе с отчётностью и требованиями по соответствию. Знать эту часть заранее не менее важно, чем сам перечень льгот.",
        },
        {
            type: "list",
            items: [
                "Сдача отчётности с установленной периодичностью и подтверждение показателей деятельности.",
                "Сохранение вида деятельности: основная часть дохода должна поступать по разрешённому направлению.",
                "Отчисления в дирекцию. В 2026 году появлялись сообщения об изменении этого порядка, но подтверждающего документа с номером мы не нашли — поэтому цифру здесь не приводим. Действующий размер и порядок уточняйте в официальном источнике.",
                "Для отдельного юрлица — самостоятельная бухгалтерия, банковский счёт и документооборот.",
                "При нарушении требований статус может быть приостановлен, поэтому соответствие нужно отслеживать постоянно.",
            ],
        },

        { type: "h2", text: "Чем резидент отличается от обычной компании?" },
        {
            type: "p",
            text:
                "Таблица ниже нужна для быстрого решения. Она не даёт цифр, а показывает, какие статьи сравнивать в собственном расчёте.",
        },
        {
            type: "table",
            head: ["Статья", "Резидент IT Park", "Обычная компания", "Что посчитать"],
            rows: [
                [
                    "Налог на прибыль",
                    "Освобождение",
                    "В общеустановленном порядке",
                    "Годовая налогооблагаемая прибыль × действующая ставка",
                ],
                [
                    "Налог на имущество",
                    "Освобождение",
                    "В общеустановленном порядке",
                    "База по имуществу × действующая ставка",
                ],
                [
                    "Импорт оборудования",
                    "Освобождение от пошлин и НДС",
                    "Оплачивается полностью",
                    "Стоимость импорта, запланированного на ближайшие 2 года",
                ],
                [
                    "Офис",
                    "Достаточно виртуального",
                    "Требуется физический адрес",
                    "Экономия на аренде помещения",
                ],
                [
                    "Иностранные специалисты",
                    "Привлечение без отдельного разрешения",
                    "Оформление в общем порядке",
                    "Время и стоимость оформления",
                ],
                [
                    "Административная нагрузка",
                    "Отчётность, отчисления, сохранение вида деятельности",
                    "Обычная отчётность",
                    "Годовая стоимость бухгалтерии и юридического сопровождения",
                ],
            ],
        },

        { type: "h2", text: "Когда резидентство оказывается лишним?" },
        {
            type: "p",
            text:
                "Этот раздел пишут редко, а на практике он нужен чаще остальных. В перечисленных ниже случаях статус отнимет больше времени, чем принесёт экономии.",
        },
        { type: "image", image: 2 },
        {
            type: "list",
            items: [
                "Команда маленькая и прибыль небольшая. Льгота по налогу на прибыль привязана к налогооблагаемой базе: при небольшой прибыли и экономия окажется скромной.",
                "Система сделана только для внутреннего пользования. Если программный продукт не продаётся и обслуживает лишь ваши процессы, условие по виду деятельности может не выполняться.",
                "Нет ресурса на содержание отдельного юрлица. Вторая бухгалтерия, вторая отчётность и внутренние договоры — это постоянный расход.",
                "Горизонт планирования меньше года. Время на заявление, регистрацию и настройку на коротком проекте не окупается.",
                "Основной доход приходит из другого направления, и его выделение ломает бизнес-логику.",
            ],
        },
        {
            type: "p",
            text:
                "Простая проверка: посчитайте годовую экономию и вычтите из неё годовые административные расходы на отдельное юрлицо. Экономический смысл появляется только при заметном положительном результате.",
        },

        { type: "h2", text: "Что теряет компания без резидентства?" },
        {
            type: "p",
            text:
                "Потери бывают двух видов. Первый — прямой: сумма налогов, рассчитанная по формуле выше, продолжает уплачиваться каждый год. Для прибыльной IT-компании это заметная цифра.",
        },
        {
            type: "p",
            text:
                "Второй вид менее очевиден — кадры и оборудование. Без упрощений по привлечению иностранных специалистов и ввозу техники оба процесса на стадии роста идут медленнее. Это потеря не денег, а времени, но она тоже конвертируется в стоимость.",
        },
        {
            type: "quote",
            text:
                "Льгота сама по себе не выгода. Выгода появляется только тогда, когда сэкономленная сумма превышает административную нагрузку.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Четыре вопроса для решения" },
        {
            type: "ol",
            items: [
                "Ваш программный продукт или IT-услуга продаются или используются только внутри компании?",
                "Какова годовая налогооблагаемая прибыль и сколько даёт льгота в деньгах?",
                "Есть ли ресурс на содержание отдельного юридического лица?",
                "Горизонт вашего плана длиннее года?",
            ],
        },
        {
            type: "p",
            text:
                "Если на первый вопрос ответ «продаются», по второму выходит заметная сумма, а на два оставшихся ответ «да» — резидентство вам выгодно. При смешанных ответах сначала доведите расчёт до конца и только потом подавайте заявление.",
        },
    ],

    faq: [
        {
            q: "От каких налогов освобождается резидент IT Park?",
            a: "В официальном источнике указаны следующие льготы: освобождение от налога на прибыль, налога на имущество, таможенных платежей и НДС на ввозимое оборудование. Дополнительно предоставляется право на виртуальный офис и возможность привлекать иностранных специалистов без отдельного разрешения. Всё, что не входит в перечень, остаётся в обычном порядке.",
        },
        {
            q: "Может ли торговая или производственная компания стать резидентом?",
            a: "Да, если IT-направление выделено в отдельное юридическое лицо и его деятельность связана с разработкой программного продукта или IT-услуг. Схема работает при двух условиях: новая компания ведёт реальную деятельность, а внутренние услуги оформляются по рыночной цене. Требуется настоящее разделение, а не формальность на бумаге.",
        },
        {
            q: "Сколько составляют отчисления в дирекцию?",
            a: "Конкретную цифру мы здесь не приводим. В 2026 году появлялись сообщения об изменении порядка отчислений, но подтверждающего документа с номером найти не удалось, а неподтверждённые цифры мы не публикуем. Действующий размер и порядок расчёта проверьте в официальном источнике дирекции IT Park или через своего бухгалтера.",
        },
        {
            q: "Сколько времени занимает получение статуса?",
            a: "Гарантированного срока нет, он зависит от полноты пакета документов. Больше всего времени обычно уходит на план деятельности и описание продукта — именно этого документа чаще всего не хватает. Практическая рекомендация: не привязывайте план разработки к получению статуса, ведите оба процесса параллельно.",
        },
        {
            q: "Могут ли статус резидента отозвать?",
            a: "Да. Резидентство сопровождается постоянными обязанностями: сдача отчётности с установленной периодичностью, сохранение вида деятельности и получение основной части дохода по разрешённому направлению. При нарушении требований статус может быть приостановлен. Поэтому контроль соответствия стоит встроить в бухгалтерский процесс, а не оставлять как ежегодное событие.",
        },
        {
            q: "Нужно ли резидентство небольшой команде?",
            a: "Чаще всего нет. Льгота по налогу на прибыль привязана к налогооблагаемой базе: при небольшой прибыли экономия получается скромной. Отдельное юрлицо при этом требует постоянной бухгалтерии, отчётности и внутренних договоров. Сначала посчитайте экономию, затем вычтите из неё годовые административные расходы и решайте по результату.",
        },
    ],

    cta: {
        h: "Посчитаем, выгодно ли резидентство именно вам",
        p:
            "Разберём ваш вид деятельности и финансовые показатели, сопоставим экономию с административной нагрузкой. Если статус окажется для вас лишним, скажем об этом прямо.",
        button: "Получить консультацию",
    },

    images: [
        {
            src: "/assets/img/blog/it-park-ofis.webp",
            alt: "Современный офис технопарка — среда, в которой работают IT-компании",
            caption: "Резидентство — это статус, а не здание: достаточно виртуального офиса",
            prompt:
                "Modern tech-park office lobby with a glass facade, developers walking through, a wall of monitors in the background; bright architectural photography style, neutral corporate palette, no brand signage, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/it-park-imtiyozlar.webp",
            alt: "Панель с четырьмя основными льготами для резидента IT Park",
            caption: "Всё, что не вошло в перечень, остаётся в обычном порядке",
            prompt:
                "Benefits panel: four tiles with simple icons representing profit tax exemption, property tax exemption, customs duty relief on imported equipment, and hiring foreign specialists without a permit; clean flat tiles on light background, blue and green, no readable text, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/it-park-qaror.webp",
            alt: "Дерево решений по вопросу о необходимости резидентства IT Park",
            caption: "Ответ начинается с вида деятельности, а не с перечня льгот",
            prompt:
                "Decision flowchart with diamond decision nodes: does the company produce software or IT services for sale or export, leading to three outcomes — residency worth it, worth it via a separate legal entity, not worth it; clean flowchart on light background, blue with one grey exit branch, no readable text, no logos, 4:3",
        },
        {
            src: "/assets/img/projects/ung-academy.webp",
            alt: "Платформа UNG Academy — пример компании с собственным программным продуктом",
            caption: "Компания с продаваемым продуктом — самый однозначный случай для статуса",
        },
    ],

    relatedServices: ["it-autsorsing", "startap-saytlar", "veb-ilovalar"],
    relatedPosts: ["oz-dasturchisi-yoki-autsorsing", "ariza-tannarxi-seo-ads-instagram", "web-sayt"],
};

const content = { uz, ru };

export default content;
